///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class NotImplementedException extends Error {
    constructor(message = 'Not implemented') {
        super(message);
        this.name = 'NotImplementedException';
    }
}
